module.exports = __webpack_public_path__ + "static/media/data-dashboard.0b4fbacf.png";